module.exports = __webpack_public_path__ + "img/member-axd2.87a406bd.png";